<template>
  <div>
    <pageTable />
  </div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'financial-financial-userMaterialAbnormal',
  components: {
    PageTable,
  },
}
</script>
